export const CLAIM_BREADCRUMB_KEY = "claim-id";

export const CLAIM_TAB_BREADCRUMB_KEY = "claim-tab";

export const CLAIM_RESUME_BREADCRUMB_KEY = "claim-resume";

export const CATASTROPHE_EVENT_BREADCRUMB_KEY = "catastrophe-event-id";

export const HOME_BREADCRUMB_KEY = "home";

export const CLAIMS_MODULE_BREADCRUMB_KEY = "claims-module";
